import { useDispatch } from 'react-redux';
import { setMessage } from '../features/toasts/toastSlice';

function useNotificationMessage() {
  const dispatch = useDispatch();

  const showNotificationMessage = (message, notificationType) => {
    dispatch(
      setMessage({
        body: message,
        type: notificationType,
      })
    );
  };

  return { showNotificationMessage };
}

export default useNotificationMessage;
